export default {
  classTrans: '轉班',
  classTransDiff: '差價轉班',
  actuallyPrice: '目標班級應繳學費',
  remainingFee: '當前班級剩餘學費',
  refundTotal: '實退金額',
}
